import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { updateOutcomes } from "./api";
import { invalidateAllQueries } from "utils/utils";

export function useUpdateOutcome({ ...options } = {}) {
    return useMutation({
        mutationFn: ({ id, item }) => updateOutcomes({ id, item }),
        onSuccess: (data) => {
            invalidateAllQueries();
            toast.success("Outcome updated");
            options.onSuccess?.(data);
        },
        onError: (err) => {
            toast.error("Error updating outcome");
            options.onError?.(err);
        },
    });
}